import { connect } from 'react-redux';
import MarkComplete from './MarkComplete';
import { updateLessonCompletedProgress } from '../../actions/my-progress';

const mapState = (state, props) => {
  return { ...props };
};
const mapDispatch = {
  updateLessonCompletedProgress,
};
export default connect(mapState, mapDispatch)(MarkComplete);
